import {
  PortalBlock,
  BlockIndexData,
  BlockPlaceData,
  BlockSizeData,
  BlockUpdateData,
  BlockActionsData,
  BlockVisibilityData,
} from '@nx-frontend/shared/types';

export const blockToBlockActions = (block: PortalBlock): BlockActionsData => {
  const { id, actions } = block;
  return { id, actions };
};
export const blockToBlockIndex = (block: PortalBlock): BlockIndexData => {
  const { id, index, place } = block;
  return { id, index, place };
};

export const blockToBlockPlace = (block: PortalBlock): BlockPlaceData => {
  const { id, index, place } = block;
  return { id, index, place };
};

export const blockToBlockSize = (block: PortalBlock): BlockSizeData => {
  const { id, rowspan, colspan, mediaSizes } = block;
  return { id, rowspan, colspan, mediaSizes };
};

export const blockToBlockVisibility = (block: PortalBlock): BlockVisibilityData => {
  const { id, enabled } = block;
  return { id, enabled };
};

export const blockToBlockUpdate = (block: PortalBlock): BlockUpdateData => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, index, place, rowspan, colspan, ...blockUpdateData } = block;
  return blockUpdateData;
};
